// extracted by mini-css-extract-plugin
export default {"container":"style_container__oJcU7","chat":"style_chat__8TRU-","background":"style_background__Bjgnm","list":"style_list__vlf-T"};